import React from 'react'
import Content02 from './Content02'
import Content03 from './Content03'
import Content04 from './Content04'
import Content05 from './Content05'
import Content06 from './Content06'
import Content07 from './Content07'
import Content01 from './Content01'
import styled from 'styled-components'
import StartButton from './StartButton'
import Note from './Note'
import DownloadApp from '@components/NewMain/DownloadApp'

const Index = () => {
  return (
    <Container>
      <ContentContainer>
      <ImgContainer>
        <First>
          <Content01 />
          <Content04 />
        </First>
        <Second>
          <Content02 />
          <Content05 />
        </Second>
        <Third>
          <Content03 />
          <Content06 />
          <Content07 />
        </Third>
      </ImgContainer>
        <SourceContainer>
          <Source>출처: 메타로고스(주) <Line /> 기준일: 2024년 11월 1일</Source>
        </SourceContainer>
      </ContentContainer>
      <ButtonContainer>
        <LogoImg src={'/img/main/ML_logo.svg'} />
      </ButtonContainer>
      <Note />
      <InstaLogo>
        {/* <img src={'/img/main/insta.svg'} alt='' /> */}
      </InstaLogo>
      <DownloadApp />
    </Container>
  )
}

const InstaLogo = styled.div`
  padding: 16px 0px;
  display: flex;
  float: left;
  width: 1280px;
`

const LogoImg = styled.img`
  margin-bottom: 104px;
`

const ContentContainer = styled.div`
  width: 1280px;
  display: flex;
  flex-direction: column;
`
const Source = styled.div`
  color: #414351;
  font-size: 14px;
  font-weight: 400;
  line-height: 120%;
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: end;
`
const Container = styled.div`
  width: 100%;
  justify-content: center;
  align-items: center;
  display: flex;
  flex-direction: column;
  min-width: 1280px;
`

const Line = styled.div`
  width: 1.012px;
  height: 12.688px;
  background-color: #414351;
`

const ImgContainer = styled.div`
  width: 1280px;
  display: flex;
  justify-content: center;
  gap: 24px;
  margin: 104px 0px 16px 0px;
`

const First = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 437px;
`

const Second = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 497px;
`

const Third = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`

const ButtonContainer = styled.div`
  padding: 72px 0px;
  box-sizing: border-box;
`

const SourceContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: end;
  width: 1280px;
`
export default Index
